/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Category_ProfessionalInputs */



/**
* | output |
* | --- |
* | "Professional" |
*
* @param {Voice_Manager_Elevenlabs_Category_ProfessionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_category_professional = /** @type {((inputs?: Voice_Manager_Elevenlabs_Category_ProfessionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Category_ProfessionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Professionnelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Professionell")
	if (locale === "it") return /** @type {LocalizedString} */ ("Professionale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профессиональный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Profesional")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("专业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロフェッショナル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोफ़ेशनल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Profissional")
	return /** @type {LocalizedString} */ ("Professional")
});